import { Subject } from 'rxjs';

export const transcriptionSubject = new Subject<{
  id: string;
  text: string;
}>();
